export const languageMap = {
  en: "English",
  fr: "French",
  ar: "Arabic",
};

export const reverseLanguageMap = {
  English: "en",
  French: "fr",
  Arabic: "ar",
};

export const getSystemLanguage = async () => {
  const i18next = await import("../i18n/i18n");
  return i18next.default.language || "en"; 
};